<template>
  <!-- <pre v-if="responseData">testData={{ responseData }}</pre> -->
  <AdminBackground v-if="responseData">
    <div class="image-wrapper">
      <img
        src="@/assets/header/KEWANGAN.png"
        alt="KEWANGAN"
        class="pbt-image"
      >
      <!-- Center the line under the image -->
      <div class="line-under-image" />
    </div>



    <div class="content-wrapper">
      <AppAutocomplete
        v-model="selectedYear"
        label="Tahun"
        :items="years"
        placeholder="Pilih Tahun"
        chips
        class="app-date-picker"
      />
      <h2>Peruntukan dan Prestasi Belanja Mengurus</h2>
      <div class="tindakan">
        <div
          v-for="(tindakan, index) in tindakanData"
          :key="index"
          class="tindakan-container"
        >
          <img
            src="@/assets/spah/box.png"
            :alt="tindakan.altText"
            class="responsive-image"
          >
          <div class="text-overlay">
            <div class="values-layered">
              <h3>{{ tindakan.title }}</h3>
              <p class="number">
                {{ tindakan.count }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="chart-wrapper">
        <PieChart :chart-data="belanjaData" />
      </div>
      <Update />
    </div>


    <PrimaryModule />
    <KhidmatPengurusan />
  </AdminBackground>
</template>

<script setup>
import KhidmatPengurusan from '@/components/menu-items/section-menu/khidmat-pengurusan-menu.vue'
import { useHttpService } from "@/httpService"
import { onMounted, ref } from 'vue'


definePage({
  alias: '/pages/pages/inspektorat/i-tegur',
  meta: {
    layout: 'blank',
    public: true,
  },
})

const belanjaData = ref([])
const years = ref([2022, 2023, 2024, 2025, 2026])
const selectedYear = ref(2026)
const responseData = ref(null)

// Computed property to map API data to display values
const tindakanData = computed(() => {
  if (!responseData.value || responseData.value.length === 0) {
    return [
      { title: 'Peruntukan Asal', count: `RM 0`, altText: 'First Image' },
      { title: 'Peruntukan Kemaskini', count: `RM 0`, altText: 'Second Image' },
      { title: 'Perbelanjaan', count: `RM 0`, altText: 'Third Image' },
    ]
  }

  const data = responseData.value[0] // Assuming API returns an array
  
  return [
    { title: 'Peruntukan Asal', count: `RM ${data.base_budget}`, altText: 'First Image' },
    { title: 'Peruntukan Kemaskini', count: `RM ${data.update_budget}`, altText: 'Second Image' },
    { title: 'Perbelanjaan', count: `RM ${data.used_budget}`, altText: 'Third Image' },
  ]
})

const { httpGet, numberWithCommas } = useHttpService()

const displayNameMapping = {
  // eslint-disable-next-line camelcase
  used_budget: "Perbelanjaan",
  // eslint-disable-next-line camelcase
  unused_budget: "Baki Perbelanjaan",
}


function filterSpecificData(data) {
  const categoriesToDisplay = ['used_budget', 'unused_budget']

  return Object.entries(data)
    .filter(([name]) => categoriesToDisplay.includes(name))
    .map(([name, value]) => ({
      name: displayNameMapping[name],
      value: parseFloat(value).toFixed(2), 
    }))
}

async function loadDataFromApi(year) {
  try {
    const response = await fetch(`https://ejkt.kpkt.gov.my/eprofil/api/gate/management_budgets?year=${year}`)
    const apiResponse = await response.json()


    responseData.value = apiResponse.data?.data || []

    const data = responseData.value[0]
    if (data) {
      belanjaData.value = [
        { name: "Perbelanjaan", value: parseFloat(data.used_budget.replace(/,/g, '')) || 0 },
        { name: "Baki Perbelanjaan", value: parseFloat(data.unused_budget.replace(/,/g, '')) || 0 },
      ]
    }



  } catch (err) {
    console.error('loadDataFromApi failed:', err)
    responseData.value = [] 
  }
}

watch(selectedYear, newYear => {
  loadDataFromApi(newYear) 
})

// Initial data load
onMounted(() => {
  loadDataFromApi(selectedYear.value)
})
</script>

<style scoped>
.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}

.pbt-image {
  block-size: auto;
  max-inline-size: 70%; /* Adjusted size */
}

.line-under-image {
  border-radius: 5px;
  background-color: white;
  block-size: 5px;
  inline-size: 70%; 
  margin-block-start: 10px;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  padding: 20px;
  background-color: rgba(255, 255, 255, 65%); 
  border-radius: 20px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2);
  margin: 20px 0;
}




h2 {
  color: rgb(21, 0, 105);
  font-size: 1.5rem;
  font-weight: bold;
  inline-size: 100%;
  margin-block: 40px 10px;
  text-align: left;
  text-transform: uppercase;
}


.tindakan {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* 3 columns */
  grid-gap: 10px; /* Gap between the rows and columns */
}

.tindakan-container {
  border-radius: 10px;
  overflow: hidden;
  position: relative;
}


.responsive-image {
  width: 100%;
  height: auto;
  display: block;
}

.text-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-family: Arial, sans-serif;
  text-align: center; /* Centers the text horizontally */
}

.values-layered h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #150069;
  text-align: center;
}

.number {
  font-size: 24px;
  font-weight: bold;
  color: #a80000;
  text-align: center;
}

.chart-wrapper {
  padding: 20px;
  border-radius: 10px;
  background: rgba(255, 254, 254, 80%);
  inline-size: 100%;
  max-inline-size: 1400px;
  margin-top: 40px;
}

@media (max-width: 768px) {
  .tindakan {
    grid-template-columns: repeat(2, 1fr); /* 2 columns on medium screens */
  }
}

/* For small screens, 480px and below */
@media (max-width: 480px) {
  .tindakan {
    grid-template-columns: 1fr; /* 1 column on small screens */
  }

  h2 {
    font-size: 1.3rem; /* Adjust heading font size for smaller screens */
  }

  .number {
    font-size: 20px; /* Slightly smaller font size for numbers on small screens */
  }
}
</style>
